import { useCallback } from 'react';

import BaseEquipmentCard from 'components/cards/BaseEquipmentCard';

import useNavigation from 'hooks/useNavigation';
import usePageRoutes from 'hooks/usePageRoutes';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const ControllerCard: FunctionComponent<Props> = ({
    className = '',
    controller,
    deleteController,
    testId = TEST_ID
}) => {
    const { navigate } = useNavigation();
    const { editControllerPage } = usePageRoutes();

    const { id } = controller;

    const onEdit = useCallback(() => {
        navigate(editControllerPage(id));
    }, [editControllerPage, id, navigate]);

    return (
        <BaseEquipmentCard
            className={className}
            equipment={controller}
            onDelete={deleteController}
            onEdit={onEdit}
            testId={testId}
        />
    );
};

export default ControllerCard;
